import React, { useContext, useState, useEffect } from 'react';
import toast from 'react-hot-toast';

import { DataContext } from '../../../init/getData';

import { Col, Form, Row, DropdownButton, Dropdown, InputGroup, Card } from 'react-bootstrap';
import { Space, Input, Tag, Button, Spin, Tabs, Checkbox } from 'antd';
import Modal from 'react-bootstrap/Modal';

import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcKindle, FcCancel, FcPlus } from "react-icons/fc";
import { FaCheck } from "react-icons/fa";
import { HiMinusCircle } from "react-icons/hi";

import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import Loader from '../../../components/loader/loader';

import { numberFormatter, totalFormatter, decimalFormatter } from '../../../components/formatters/numberFormatter';

const InvoicePayment = (props) => {

    const { journalVoucher, setJournalVoucher, validated } = props;

    const { api, userData, settingData, accountData, wareHouseData, selectedCompany,
        productData, refData, branchData, projectData, currencyData } = useContext(DataContext);


    const userId = userData.id;
    const userName = userData.name;
    const userRole = userData.role.name;
    const createdBy = parseInt(userData.id);

    const { showModal, toggleModal, table, title, refreshTable, size, footer, idRow, type } = props;
    const [loadingEffect, setLoadingEffect] = useState(false);
    const [isSpinning, setIsSpinning] = useState(false);
    const [isLoading, setIsLoading] = useState(true);



    // Account Options
    const accountOptions = accountData?.map(item => ({
        value: item.id,
        label: `${item.chartId}.${item.accountId} ${item.name}`,
        name: item.name,
    }));

    // Load and filter account options
    const loadAccountOptions = (inputValue, callback) => {
        const filteredOptions = inputValue ? accountOptions.filter(option =>
            option.label.toLowerCase().includes(inputValue.toLowerCase())) : [];

        filteredOptions.push({ value: null, label: 'no supplier' });
        callback(filteredOptions);
    };

    // Currency Options
    const currencyOptions = currencyData?.map(item => ({
        value: item.id,
        label: item.code,
        symbol: item.symbol,
        rate: item.rate,
        vatRate: item.vatRate,
    }));


    // WareHouse Options
    const wareHouseOptions = wareHouseData?.map(item => ({
        value: item.id,
        label: item.name,
    }))


    // Branch Options
    const branchOptions = branchData?.map(item => ({
        value: item.id,
        label: item.name,
    }));

    // Project Options
    const projectOptions = projectData?.map(item => ({
        value: item.id,
        label: item.name,
    }))


    // Generic handler for input changes
    const handleInputChange = (e, type) => {
        let { name, value } = e.target;
        if (name == 'paymentType') {
            if (!journalVoucher.accountId) {
                toast.error('Please select account')
                return;
            }
        }
        setJournalVoucher((prev) => ({
            ...prev,
            [name]: value,
        }));
    };


    const onCheckChange = (e) => {
        const name = e.target.name;
        const checked = e.target.checked;
        setJournalVoucher((prev) => ({
            ...prev,
            [name]: checked,
        }));
    };

    return (

        <div>


            <Row className="mb-3">

                <Col>
                    <Form.Label column="sm" sm="4">
                        PaymentType
                    </Form.Label>
                    <Form.Select name="paymentType"
                        value={journalVoucher.paymentType}
                        onChange={(e) => handleInputChange(e, 'text')}
                    >
                        <option value={'cash'}>Cash</option>
                        <option value={'onAccount'}>onAccount</option>
                    </Form.Select>
                </Col>

                <Col>
                    <Form.Label column="sm" sm="4">
                        DownPayment
                    </Form.Label>
                    <Form.Control type="number" step="any" name="downPayment"
                        value={journalVoucher.downPayment}
                        onChange={(e) => handleInputChange(e, 'text')}
                        disabled={journalVoucher.paymentType == 'cash'} />
                </Col>

            </Row>

            {journalVoucher.paymentType == 'onAccount' &&
                <Row className="mb-1">
                    <Col>
                        <Checkbox onChange={onCheckChange} checked={journalVoucher.isScheduled} name="isScheduled">
                            Schedule Payments
                        </Checkbox>
                    </Col>
                </Row>
            }

            {journalVoucher.isScheduled &&

                <Row className="mb-3">

                    <Col>
                        <Form.Label column="sm" sm="4">
                            PaymentType
                        </Form.Label>
                        <Form.Select name="paymentType"
                            value={journalVoucher.paymentType}
                            onChange={(e) => handleInputChange(e, 'text')}
                        >
                            <option value={'weekly'}>Weekly</option>
                            <option value={'monthly'}>Monthly</option>
                            <option value={'yearly'}>Yearly</option>
                        </Form.Select>
                    </Col>

                    <Col>
                        <Form.Label>Date<span style={{ color: 'red' }}>*</span></Form.Label>
                        <input type="date" className="form-control form-control" name='date'
                            onChange={(e) => handleInputChange(e, 'text')}
                            value={journalVoucher.date}
                            required
                        ></input>
                    </Col>

                </Row>
            }
        </div >

    )
}


export default InvoicePayment;